import moment from 'moment'

export const isDateInPast = (date, useDiffInMinutes, createdAt) => {
  if (!date) return false
  const dateToday = createdAt ? moment.utc(createdAt * 1000) : moment().utc()
  const dateToCompare = date.clone()

  // because on billing dynamics we are using only dates, and on terms of cancellation we are using exact hours:minutes
  // so if we book at the treshold day before treshold we will still write exact terms of cancellation
  if (!useDiffInMinutes) {
    dateToday.hours(12).minutes(0).seconds(0).milliseconds(0)
    dateToCompare.hours(12).minutes(0).seconds(0).milliseconds(0)
  }

  const diff = dateToCompare.diff(dateToday, useDiffInMinutes ? 'minutes' : 'days')

  return !(diff >= 0)
}
